import { UserServiceClient } from 'fitbeat.api-clients';
import { UserProfile } from 'fitbeat.gym-core';
import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { StrengthRatioForMuscleGroups } from '../../../models/src';
import { StrengthLevel } from '../auth/StrengthLevel';
import { getApiConfig } from '../config/index';
import theme from '../theme';
import { AuthTokenBuilder } from '../utils';
import { Logger } from '../utils/Logger';
import { defaultScale } from '../utils/scaling';
import { saveManualStrengthAssessment } from './actions';
import { selectIsAssessmentResultLoading } from './selectors';

interface IStateProps {
  isAssessmentResultLoading: boolean;
}

interface IDispatchProps {
  saveStrengthRatios(userStrengthRatios: StrengthRatioForMuscleGroups): void;
}
interface IProps {
  userProfile: UserProfile;
  getNextStep(): void;
  t(key: string): string;
}

type ComponentProps = IProps & IStateProps & IDispatchProps;

export const GeneralStrengthLevelComponent: React.FC<ComponentProps> = ({
  isAssessmentResultLoading,
  saveStrengthRatios,
  userProfile,
  getNextStep,
  t,
}) => {
  if (isAssessmentResultLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size='small' color={theme.PRIMARY} animating={true} />
      </View>
    );
  }
  return (
    <View style={styles.container}>
      <StrengthLevel
        gender={userProfile.gender}
        levelSelectionCb={(
          userStrengthRatios: StrengthRatioForMuscleGroups,
        ) => {
          saveStrengthRatios(userStrengthRatios);
          getNextStep();
        }}
      />
    </View>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isAssessmentResultLoading: selectIsAssessmentResultLoading(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const userServiceClient = new UserServiceClient(
    getApiConfig(),
    fetch,
    Logger.debug,
    new AuthTokenBuilder(),
  );
  return {
    saveStrengthRatios: (ratios: StrengthRatioForMuscleGroups) => {
      dispatch(saveManualStrengthAssessment(userServiceClient, ratios));
    },
  };
};

export const GeneralStrengthLevelQuesiton: React.FC<IProps> = connect<
  IStateProps,
  IDispatchProps,
  IProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(GeneralStrengthLevelComponent);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: defaultScale(15),
  },
  buttonContainer: {
    marginHorizontal: defaultScale(15),
    height: defaultScale(45),
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
